import Vue from 'vue'
import Vuex from 'vuex'
// 实名认证
import m_relNameAuth from './modules/relNameAuth.js'
import login from './modules/login.js'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    m_relNameAuth,
    login
  }
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js